/** Route of the admin version scoreboard for the family `cohortId` belongs to.
 * Pure leaf helper so the case panel can link to it without importing the page. */
export function surfacerScoreboardPath(cohortId: string): string {
  return `/admin/surfacer-scoreboard/${encodeURIComponent(cohortId)}`;
}
